import { MARQUEE_ITEMS } from "@/lib/data";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="overflow-hidden border-y border-line bg-panel" data-testid="marquee">
      <div className="flex w-max animate-marquee items-center py-4">
        {items.map((item, i) => (
          <span key={i} className="flex items-center font-mono text-xs uppercase tracking-[0.3em] text-hazard">
            <span className="px-8">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-brass" />
          </span>
        ))}
      </div>
    </div>
  );
}
